import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export interface PdfPreviewInput {
  content: string;
  header?: string;
  title?: string;
  options?: {
    cacheKey?: string;
    extraStyles?: string;
  };
}

export interface PdfPreviewOptions {
  cacheKey?: string;
  extraStyles?: string;
}

const HEADER_HTML = `<table width="100%" class="border_bottom">
    <tr>
        <th rowspan="2"><img
                src="data:image/png;base64,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"  width="69" height="90">
        </th>
        <th colspan="4" class="bold" valign="bottom" style="padding-bottom: 0"><font size="4">MINISTERUL FINANŢELOR AL REPUBLICII MOLDOVA</font></th>
    </tr>
    <tr>
        <th colspan="4" class="bold" valign="top" style="padding-top: 0"><font size="4">SERVICIUL VAMAL</font></th>
    </tr>
</table>`;

const DEFAULT_PDF_STYLES = `
  body {
    font-family: sans-serif, Arial, Verdana, "Trebuchet MS";
    font-size: 13px;
    line-height: 1.6;
    color: #000;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: normal;
    line-height: 1.2;
  }

  table {
    border-collapse: collapse;
    width: 100%;
  }

  .table-border {
    border-collapse: collapse;
    width: 100%;
    page-break-inside: avoid;
  }
`;

const createPreviewHtml = ({
  content,
  header,
  title,
  extraStyles,
}: Required<Pick<PdfPreviewInput, "content" | "header" | "title">> & {
  extraStyles?: string;
}) => {
  const headerToUse = header && header.trim() !== "" ? HEADER_HTML : "";

  
  return `
    <!DOCTYPE html>
    <html lang="en">
      <head>
        <meta http-equiv="content-type" content="text/html; charset=utf-8">
        <title>${title}</title>
        <style>
          body {
            font-family: sans-serif, Arial, Verdana, "Trebuchet MS", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
            font-size: 13px;
            line-height: 1.6;
            white-space: pre-wrap;
            margin: 0;
            padding: 0;
          }

          h1, h2, h3, h4, h5, h6 {
            font-weight: normal;
            line-height: 1.2;
          }

          .border_bottom {
            border-bottom: 4px double black;
          }

          table {
            border-collapse: collapse;
            width: 100%;
          }

          img {
            max-width: 100%;
            height: auto;
            display: block;
          }

          ${DEFAULT_PDF_STYLES}
          ${extraStyles || ""}
        </style>
      </head>
      <body>
        ${headerToUse}
        ${headerToUse ? "<br>" : ""}
        ${content}
      </body>
    </html>
  `;
};


const createHiddenContainer = (html: string): Promise<{
  container: HTMLDivElement;
  styleElement: HTMLStyleElement;
}> => {
  return new Promise((resolve) => {
    const container = document.createElement("div");
    container.style.position = "absolute";
    container.style.left = "-9999px";
    container.style.top = "0";
    container.style.width = "210mm"; // A4 width
    container.style.padding = "20mm";
    container.style.backgroundColor = "#fff";
    container.setAttribute("data-pdf-preview", "true");

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const styles = Array.from(doc.querySelectorAll("style"));
    const styleElement = document.createElement("style");
    styleElement.setAttribute("data-pdf-preview", "true");
    styles.forEach((style) => {
      styleElement.textContent += (style.textContent || "") + "\n";
    });
    document.head.appendChild(styleElement);

    const bodyContent = doc.body.innerHTML;
    container.innerHTML = bodyContent;
    document.body.appendChild(container);
    
    waitForImages(container).then(() => {
      setTimeout(() => {
        resolve({ container, styleElement });
      }, 500);
    });
  });
};

const waitForImages = (container: HTMLElement): Promise<void> => {
  return new Promise((resolve) => {
    const images = Array.from(container.querySelectorAll("img"));
    if (images.length === 0) {
      resolve();
      return;
    }

    let loadedCount = 0;
    const checkComplete = () => {
      loadedCount++;
      if (loadedCount === images.length) {
        resolve();
      }
    };

    images.forEach((img) => {
      if (img.complete) {
        checkComplete();
      } else {
        img.onload = checkComplete;
        img.onerror = checkComplete;
      }
    });
  });
};

const previewPdfCache = new Map<string, ArrayBuffer>();

const getCacheKey = (
  content: string,
  header: string,
  options?: PdfPreviewOptions
): string => {
  return options?.cacheKey || `${content}:${header}`;
};

export const generatePreviewPdfArrayBuffer = async ({
  content,
  header = "",
  title = "Preview",
  options = {},
}: PdfPreviewInput): Promise<ArrayBuffer> => {
  if (!content && !header) {
    throw new Error("Preview content is empty.");
  }

  const cacheKey = getCacheKey(content, header, options);
  const cached = previewPdfCache.get(cacheKey);
  if (cached) {
    return cached;
  }

  const html = createPreviewHtml({
    content,
    header,
    title,
    extraStyles: options.extraStyles,
  });

  const hiddenContainerResult = await createHiddenContainer(html);
  const { container } = hiddenContainerResult;

  try {
    const canvas = await html2canvas(container, {
      scale: 2,
      useCORS: true,
      logging: false,
      backgroundColor: "#ffffff",
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    const imgWidth = 210; // A4 width in mm
    const pageHeight = 297; // A4 height in mm
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    const arrayBuffer = pdf.output("arraybuffer");
    previewPdfCache.set(cacheKey, arrayBuffer);

    return arrayBuffer;
  } finally {
    hiddenContainerResult.container.remove();
    hiddenContainerResult.styleElement.remove();
  }
};

export const generatePreviewPdfBlob = async ({
  content,
  header = "",
  title = "Preview",
  options = {},
}: PdfPreviewInput): Promise<Blob> => {
  const arrayBuffer = await generatePreviewPdfArrayBuffer({
    content,
    header,
    title,
    options,
  });
  return new Blob([arrayBuffer], { type: "application/pdf" });
};
